import { Booking, OfferResponse } from 'logic/api-models/api-models';
import { AppRoute } from 'app/app.route.const';

export const isElitetutor = (offerResponse?: OfferResponse, pathname?: string) => {
  if (pathname)
    return (
      offerResponse &&
      offerResponse.hasOwnProperty('elitetutor') &&
      pathname.includes(AppRoute.EliteTutorDetails.split('/')[1])
    );
  return offerResponse && offerResponse.hasOwnProperty('elitetutor');
};

/**
 * Whether allowed to book a trial lesson.
 *
 * @remarks Personalized per logged-in user's trial eligibility.
 */
export const isTrialableOffer = (offerResponse?: OfferResponse) => {
  return offerResponse?.elitetutor?.price === null || offerResponse?.elitetutor?.price === 0;
};

export const isTrialBooking = (booking?: Booking) => {
  return booking?.details?.price === null || booking?.details?.price === 0;
};
